import React from 'react';
import { Card } from './card';
import { Thermometer } from 'lucide-react';
import { formatNumber } from '@/utils/formatNumber';

interface TemperatureData {
  sensorIndoor: {
    temperature: number;
    humidity: number;
    avgToday: {
      temperature: number;
      humidity: number;
    };
  };
  ahuTemp: {
    supply: number;
    return: number;
    avgToday: {
      supply: number;
      return: number;
    };
  };
}

interface TemperatureCardProps {
  data?: TemperatureData;
}

export function TemperatureCard({ data }: TemperatureCardProps) {
  return (
    <Card title="Temperature" icon={Thermometer} className="h-full">

      {/* Content */}
      <div className="flex flex-col gap-[8px] flex-1">
        {/* Room Temp & Humidity */}
        <div className="flex gap-2 flex-1">
          {/* Room Temp */}
          <div className="flex flex-col justify-between flex-1 pt-[6px] pb-[6px] pl-[8px] pr-[8px] bg-bg border border-light-grey rounded-[8px]">
            <div className="paragraph-11 text-dark">Room Temp</div>
            <div className="flex items-baseline gap-1">
              <span className="heading-6">{formatNumber(data?.sensorIndoor?.temperature)}</span>
              <span className="paragraph-12">°C</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="paragraph-9 text-dark-grey">Today Avg.</span>
              <span className="paragraph-9 text-gray-500">{formatNumber(data?.sensorIndoor?.avgToday?.temperature)} °C</span>
            </div>
          </div>

          {/* Relative Humidity */}
          <div className="flex flex-col justify-between flex-1 pt-[6px] pb-[6px] pl-[8px] pr-[8px] bg-bg border border-light-grey rounded-[8px]">
            <div className="paragraph-11 text-dark">Relative Humidity</div>
            <div className="flex items-baseline gap-1">
              <span className="heading-6">{formatNumber(data?.sensorIndoor?.humidity)}</span>
              <span className="paragraph-12">%</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="paragraph-9 text-dark-grey">Today Avg.</span>
              <span className="paragraph-9 text-gray-500">{formatNumber(data?.sensorIndoor?.avgToday?.humidity)}%</span>
            </div>
          </div>
        </div>

        {/* Set Temp & Return Temp */}
        <div className="flex gap-2 flex-1">
          {/* Set Temp */}
          <div className="flex flex-col justify-between flex-1 pt-[6px] pb-[6px] pl-[8px] pr-[8px] bg-bg border border-light-grey rounded-[8px]">
            <div className="paragraph-11 text-dark">Set Temp</div>
            <div className="flex items-baseline gap-1">
              <span className="heading-6">{formatNumber(data?.ahuTemp?.supply)}</span>
              <span className="paragraph-12">°C</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="paragraph-9 text-dark-grey">Today Avg.</span>
              <span className="paragraph-9 text-gray-500">{formatNumber(data?.ahuTemp?.avgToday?.supply)} °C</span>
            </div>
          </div>

          {/* Return Temp */}
          <div className="flex flex-col justify-between flex-1 pt-[6px] pb-[6px] pl-[8px] pr-[8px] bg-bg border border-light-grey rounded-[8px]">
            <div className="paragraph-11 text-dark">Return Temp</div>
            <div className="flex items-baseline gap-1">
              <span className="heading-6">{formatNumber(data?.ahuTemp?.return)}</span>
              <span className="paragraph-12">°C</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="paragraph-9 text-dark-grey">Today Avg.</span>
              <span className="paragraph-9 text-gray-500">{formatNumber(data?.ahuTemp?.avgToday?.return)} °C</span>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}

